import { observer } from 'mobx-react-lite';
import React from 'react';
import { Button, Toggle } from '@insurancemenu/imenu-components-lib';
import { Add, Search } from '@insurancemenu/imenu-components-lib/dist/icons';
import { GROUPS_FILTERS_TITLES } from 'global/utils/DashboardFilters';
import { useRootStore } from 'store/rootStore';
import { adminRights, celticsRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import { ACTION_PANEL_ACTION_BTN_TEST, SEARCH_GROUP_BTN } from '../constants';
import { ActionButtonStyled, ActionSectionStyled, PanelStyled, TitleStyled, ToggleWrapperStyled } from './styles';

interface Props {
  searchButtonTitle: string;
  onAction?: (...args: unknown[]) => void;
  onSearch?: (...args: unknown[]) => void;
  actionButtonTitle?: string;
}

const DashboardActionsPanel: React.FC<Props> = observer(
  ({ onAction, actionButtonTitle, onSearch, searchButtonTitle }) => {
    const {
      userStore: { userRoles },
    } = useRootStore();
    const { groupRequestParams, flipFullView } = useGroupDashboardPageStore();

    return (
      <PanelStyled>
        <TitleStyled>{GROUPS_FILTERS_TITLES[groupRequestParams.filter]}</TitleStyled>
        <ActionSectionStyled>
          {(celticsRights(userRoles) || adminRights(userRoles)) && (
            <ToggleWrapperStyled>
              <Toggle
                checked={groupRequestParams.fullView}
                onChange={flipFullView}
                labelActive="Admin view"
                labelInactive="Personal view"
              />
            </ToggleWrapperStyled>
          )}
          {onSearch && (
            <Button
              onClick={onSearch}
              type="outlined"
              size="large"
              leftIconProp={<Search />}
              data-test-id={SEARCH_GROUP_BTN}
            >
              {searchButtonTitle}
            </Button>
          )}
          {onAction && (
            <ActionButtonStyled
              size="large"
              width="20rem"
              onClick={onAction}
              color="primary"
              leftIconProp={<Add />}
              data-test-id={ACTION_PANEL_ACTION_BTN_TEST}
            >
              {actionButtonTitle}
            </ActionButtonStyled>
          )}
        </ActionSectionStyled>
      </PanelStyled>
    );
  },
);

export default DashboardActionsPanel;
